import axios from 'axios';

import {
    API_BASE_URL
} from '../../constants/index';

export default class PpwrDashboardService {
    static instance;

    static getInstance() {
        if (!PpwrDashboardService.instance) {
            PpwrDashboardService.instance = new PpwrDashboardService();
        }

        return PpwrDashboardService.instance;
    }

    async fetchSummary(params = {}) {
        // Replace mock implementation with real API call when backend is available.
        // const response = await axios.get(`${API_BASE_URL}/ppwr/dashboard/summary`, {
        //     params,
        //     headers: {
        //         Authorization: `Bearer ${localStorage.getItem('LOCAL_STORAGE_KEY_ACCESS_TOKEN')}`,
        //     },
        // });
        // return response.data?.data || {};

        await new Promise((resolve) => setTimeout(resolve, 350));

        return {
            readinessScore: 84,
            reviewItems: 6,
            complianceStatus: 'medium_risk',
            readinessPercentage: 84,
            activeSuppliers: 26,
            lastUpdated: '2026-07-25',
        };
    }

    async fetchPackagingMaterials(params = {}) {
        // Replace mock implementation with real API call when backend is available.
        // const response = await axios.get(`${API_BASE_URL}/ppwr/dashboard/packaging-materials`, {
        //     params,
        //     headers: {
        //         Authorization: `Bearer ${localStorage.getItem('LOCAL_STORAGE_KEY_ACCESS_TOKEN')}`,
        //     },
        // });
        // return response.data?.data || [];

        await new Promise((resolve) => setTimeout(resolve, 350));

        return [
            {
                name: 'Paper & Cardboard',
                itemCount: 14,
                riskLevel: 'low',
                compliancePercentage: 93,
            },
            {
                name: 'Plastic Wrappers',
                itemCount: 8,
                riskLevel: 'medium',
                compliancePercentage: 81,
            },
            {
                name: 'Aluminium Foil',
                itemCount: 6,
                riskLevel: 'medium',
                compliancePercentage: 83,
            },
            {
                name: 'Wooden Pallets',
                itemCount: 4,
                riskLevel: 'low',
                compliancePercentage: 90,
            },
        ];
    }

    async fetchRequirementTracker(params = {}) {
        // Replace mock implementation with real API call when backend is available.
        // const response = await axios.get(`${API_BASE_URL}/ppwr/dashboard/requirement-tracker`, {
        //     params,
        //     headers: {
        //         Authorization: `Bearer ${localStorage.getItem('LOCAL_STORAGE_KEY_ACCESS_TOKEN')}`,
        //     },
        // });
        // return response.data?.data || [];

        await new Promise((resolve) => setTimeout(resolve, 350));

        return [
            {
                id: 'req-1',
                requirement: 'Packaging recyclability',
                riskLevel: 'medium',
                status: 'red_flag',
            },
            {
                id: 'req-2',
                requirement: 'Minimum recycled content',
                riskLevel: 'medium',
                status: 'red_flag',
            },
            {
                id: 'req-3',
                requirement: 'Reusable packaging design',
                riskLevel: 'low',
                status: 'completed',
            },
            {
                id: 'req-4',
                requirement: 'Packaging waste reduction targets',
                riskLevel: 'low',
                status: 'completed',
            },
            {
                id: 'req-5',
                requirement: 'Labelling and marking requirements',
                riskLevel: 'low',
                status: 'completed',
            },
        ];
    }

    async fetchComplianceCheck(params = {}) {
        // Replace mock implementation with real API call when backend is available.
        // const response = await axios.get(`${API_BASE_URL}/ppwr/dashboard/compliance-check`, {
        //     params,
        //     headers: {
        //         Authorization: `Bearer ${localStorage.getItem('LOCAL_STORAGE_KEY_ACCESS_TOKEN')}`,
        //     },
        // });
        // return response.data?.data || {};

        await new Promise((resolve) => setTimeout(resolve, 350));

        return {
            uploadedDocuments: 40,
            processed: 34,
            issuesFound: 6,
            processingPercentage: 85,
        };
    }

    async fetchPackagingTonnageTrend(params = {}) {
        // Replace mock implementation with real API call when backend is available.
        // const response = await axios.get(`${API_BASE_URL}/ppwr/dashboard/packaging-tonnage-trend`, {
        //     params,
        //     headers: {
        //         Authorization: `Bearer ${localStorage.getItem('LOCAL_STORAGE_KEY_ACCESS_TOKEN')}`,
        //     },
        // });
        // return response.data?.data || {};

        await new Promise((resolve) => setTimeout(resolve, 350));

        return {
            series: [
                { month: '2025-08', tonnage: 16.8 },
                { month: '2025-09', tonnage: 17.3 },
                { month: '2025-10', tonnage: 18.1 },
                { month: '2025-11', tonnage: 17.6 },
                { month: '2025-12', tonnage: 18.9 },
                { month: '2026-01', tonnage: 19.4 },
                { month: '2026-02', tonnage: 20.1 },
                { month: '2026-03', tonnage: 19.8 },
                { month: '2026-04', tonnage: 20.6 },
                { month: '2026-05', tonnage: 21.2 },
                { month: '2026-06', tonnage: 22.0 },
                { month: '2026-07', tonnage: 21.5 },
            ],
        };
    }

    async fetchPackagingRiskMatrix(params = {}) {
        // Replace mock implementation with real API call when backend is available.
        // const response = await axios.get(`${API_BASE_URL}/ppwr/dashboard/packaging-risk-matrix`, {
        //     params,
        //     headers: {
        //         Authorization: `Bearer ${localStorage.getItem('LOCAL_STORAGE_KEY_ACCESS_TOKEN')}`,
        //     },
        // });
        // return response.data?.data || {};

        await new Promise((resolve) => setTimeout(resolve, 350));

        const likelihoodLabels = [90, 75, 50, 25, 10];
        const consequenceTitles = [1000, 5000, 15000, 50000, 150000];
        const cellColors = [
            ['59C94F', 'FFA049', 'FFA049', 'FF4949', '822626'],
            ['4EB8B1', '59C94F', 'FFA049', 'FF4949', 'FF4949'],
            ['4EB8B1', '4EB8B1', '59C94F', 'FFA049', 'FF4949'],
            ['4EB8B1', '4EB8B1', '4EB8B1', '59C94F', 'FFA049'],
            ['4EB8B1', '4EB8B1', '4EB8B1', '4EB8B1', '59C94F'],
        ];

        const sampleRisks = {
            '0-3': [
                {
                    id: 201,
                    secondaryId: 1,
                    supplierId: 7436,
                },
                {
                    id: 202,
                    secondaryId: 2,
                    supplierId: 7436,
                },
            ],
        
            '1-2': [
                {
                    id: 203,
                    secondaryId: 3,
                    supplierId: 7436,
                },
                {
                    id: 204,
                    secondaryId: 4,
                    supplierId: 7436,
                },
            ],

            '2-3': [
                {
                    id: 205,
                    secondaryId: 5,
                    supplierId: 7436,
                },
            ],
        
            '3-1': [
                {
                    id: 206,
                    secondaryId: 6,
                    supplierId: 7436,
                },
            ],
        };

        return {
            currency: 'EUR',
            consequences: consequenceTitles.map((title, index) => ({
                id: index + 1,
                title: String(title),
            })),
            likelihoods: likelihoodLabels.map((label, index) => ({
                id: index + 1,
                label,
            })),
            ratings: [],
            matrix: cellColors.map((rowColors, rowIndex) => (
                rowColors.map((color, colIndex) => {
                    const cellId = `${rowIndex}-${colIndex}`;

                    return {
                        id: cellId,
                        color,
                        risks: sampleRisks[cellId] || [],
                    };
                })
            )),
        };
    }
}
